import React from 'react';

const IconBell = props => (<svg viewBox="0 0 22 22" width="22px" height="22px" {...props}>
  <path d="M8.861 18.232c0 0.005 0 0.01 0 0.015c0 1.244 0.958 2.253 2.14 2.253c1.183 0 2.14-1.009 2.14-2.253 c0-0.005 0-0.01 0-0.015H8.861z" />
  <path d="M17.832 15.416l-1.926-2.979c0-0.911 0-3.139 0-3.715c0-2.506-1.695-4.594-3.944-5.065V2.513 c0-0.56-0.43-1.013-0.962-1.013c-0.531 0-0.962 0.453-0.962 1.013v1.145C7.79 4.128 6.094 6.217 6.094 8.722 c0 0.981 0 3.147 0 3.715l-1.926 2.979c-0.203 0.314-0.224 0.721-0.056 1.056s0.5 0.546 0.86 0.546h12.056 c0.359 0 0.69-0.211 0.859-0.546C18.056 16.137 18.034 15.73 17.832 15.416z" />
</svg>);

export default IconBell;
